import Base from './base'

class Resource extends Base {
  constructor () {
    super('Resource')
    this.map = {
      'icon-biaozhun': require('../assets/images/scene/icon-biaozhun.png'),
      'icon-wenkeshouke': require('../assets/images/scene/icon-wenkeshouke.png'),
      'icon-likeshouke': require('../assets/images/scene/icon-likeshouke.png'),
      'icon-PPT': require('../assets/images/scene/icon-PPT.png'),
      'icon-kejian': require('../assets/images/scene/icon-kejian.png'),
      'icon-biaoyan': require('../assets/images/scene/icon-biaoyan.png'),
      'icon-zixi': require('../assets/images/scene/icon-zixi.png'),
      'icon-kaoshi': require('../assets/images/scene/icon-kaoshi.png'),
      'icon-fangxue': require('../assets/images/scene/icon-fangxue.png'),
      'icon-fenzutaolun': require('../assets/images/scene/icon-fenzutaolun.png'),
      'icon-huihua': require('../assets/images/scene/icon-huihua.png'),
      'icon-xiake': require('../assets/images/scene/icon-xiake.png'),
      'icon-yanbo': require('../assets/images/scene/icon-yanbo.png'),
      'icon-yewan': require('../assets/images/scene/icon-yewan.png'),
      'default': require('../assets/images/scene/icon-biaozhun.png')
    }
    this.map_k = {
      'icon-biaozhun': require('../assets/images/scene/icon-biaozhun-k.png'),
      'icon-wenkeshouke': require('../assets/images/scene/icon-wenkeshouke-k.png'),
      'icon-likeshouke': require('../assets/images/scene/icon-likeshouke-k.png'),
      'icon-PPT': require('../assets/images/scene/icon-PPT-k.png'),
      'icon-kejian': require('../assets/images/scene/icon-kejian-k.png'),
      'icon-biaoyan': require('../assets/images/scene/icon-biaoyan-k.png'),
      'icon-zixi': require('../assets/images/scene/icon-zixi-k.png'),
      'icon-kaoshi': require('../assets/images/scene/icon-kaoshi-k.png'),
      'icon-fangxue': require('../assets/images/scene/icon-fangxue-k.png'),
      'icon-fenzutaolun': require('../assets/images/scene/icon-fenzutaolun-k.png'),
      'icon-huihua': require('../assets/images/scene/icon-huihua-k.png'),
      'icon-xiake': require('../assets/images/scene/icon-xiake-k.png'),
      'icon-yanbo': require('../assets/images/scene/icon-yanbo-k.png'),
      'icon-yewan': require('../assets/images/scene/icon-yewan-k.png'),
      'default': require('../assets/images/scene/icon-biaozhun-k.png')
    }
  }

  getResources () {
    return Object.keys(this.map).filter(n => n !== 'default').map(m => {
      return { name: m, src: this.map[m] }
    })
  }

  getActiveResources () {
    return Object.keys(this.map_k).filter(n => n !== 'default').map(m => {
      return { name: m, src: this.map_k[m] }
    })
  }

  getResource (name) {
    // 寻找资源映射文件
    if (!name) {
      return this.map['default']
    }
    if (name.indexOf('http') === 0) {
      return name
    } else {
      // 尝试本地映射查找
      return this.map[name] || this.map['default']
    }
  }

  getActiveResource (name) {
    // 寻找资源映射文件
    if (!name) {
      return this.map['default']
    }
    if (name.indexOf('http') === 0) {
      return name
    } else {
      // 尝试本地映射查找
      return this.map_k[name] || this.map_k['default']
    }
  }
}

export default new Resource()
